import React from 'react'
import { SettingsList } from 'src/components/Settings/SettingsList'
import SEO from 'src/seo'

const Settings = () => {
  return (
    <div>
      <SEO title="Setting" />
      <SettingsList />
    </div>
  )
}
export { Settings }
